


























import { Component, Prop, Vue } from "vue-property-decorator";
import { omit } from "lodash";
import DoKoAvatar from "./DoKoAvatar.vue";

@Component({ components: { DoKoAvatar } })
export default class DokoLoginLogo extends Vue {
  readonly imgList!: string;
  readonly HEIGHT = 80;
  readonly WIDTH = 205;
  @Prop({
    type: Boolean,
    default: false,
  })
  svg!: boolean;

  @Prop({
    type: String,
    default: "000",
  })
  imgId!: string;

  @Prop({
    type: Number,
    default: null,
  })
  x!: null | number;

  @Prop({
    type: Number,
    default: null,
  })
  y!: null | number;

  @Prop({
    type: Number,
    default: null,
  })
  h!: null | number;

  @Prop({
    type: Number,
    default: null,
  })
  w!: null | number;

  get scaleX(): number {
    if (this.w === null) {
      return this.h === null ? 1 : this.scaleY;
    } else {
      return this.w / this.WIDTH;
    }
  }
  get scaleY(): number {
    if (this.h === null) {
      return this.w === null ? 1 : this.scaleX;
    } else {
      return this.h / this.HEIGHT;
    }
  }

  get tagName() {
    return this.svg ? "g" : "div";
  }
  get urlAttrName() {
    return this.svg ? "href" : "src";
  }

  get style() {
    const style: any = {
      display: "inline-block",
      height: `${this.HEIGHT * this.scaleY}px`,
      width: `${this.WIDTH * this.scaleX}px`,
      position: "relative",
    };
    return style;
  }

  get svgAttrs() {
    const attrs: any = {
      transform: `translate(${this.x} ${this.y})`,
    };

    return attrs;
  }

  get htmlAttrs() {
    const attrs: any = {
      style: this.style,
    };
    return attrs;
  }

  get cleanAttrs() {
    return omit(this.$attrs, ["height", "width", "x", "y", "src", "href"]);
  }

  get tagAttrs() {
    return {
      ...this.cleanAttrs,
      ...(this.svg ? this.svgAttrs : this.htmlAttrs),
    };
  }
}
